var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarCodeDarkGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.54962,
    y: 3.22217,
    width: 1.40086,
    height: 5.55556,
    rx: 0.700431,
    fill: "#454A67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.65088,
    y: 3.22217,
    width: 1.40086,
    height: 5.55556,
    rx: 0.700431,
    fill: "#454A67"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9547,
    y: 3.22217,
    width: 1.40086,
    height: 5.55556,
    rx: 0.700431,
    fill: "#454A67"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75214,
    y: 3.22217,
    width: 2.10129,
    height: 5.55556,
    rx: 1.05065,
    fill: "#454A67"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.554,
    y: 3.22217,
    width: 0.700431,
    height: 5.55556,
    rx: 0.350215,
    fill: "#454A67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 11H12.4569C14.1137 11 15.4569 9.65686 15.4569 8V7.66667",
    stroke: "#454A67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44824 7.66663V7.99996C1.44824 9.65681 2.79139 11 4.44824 11H6.35126",
    stroke: "#454A67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4569 4.33337V4.00004C15.4569 2.34319 14.1138 1.00004 12.4569 1.00004H10.5539",
    stroke: "#454A67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65088 1L4.44829 1C2.79144 1 1.44829 2.34314 1.44829 4V4.33333",
    stroke: "#454A67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCodeDarkGrayOutline);
export default __webpack_public_path__ + "static/media/barCodeDarkGrayOutline.b82f11f6b413991d34443e2f84636471.svg";
export { ForwardRef as ReactComponent };